import {Component, OnInit, ViewContainerRef} from '@angular/core';
import {RestAPIService} from '../shared/shared-service/restAPI.service';
import {AuditLog} from './audit-log';
import {BlockUI, NgBlockUI} from 'ng-block-ui';
import {Subject} from 'rxjs';
import {NgIf, DatePipe} from '@angular/common';
import {NgbModal, NgbActiveModal, NgbModalOptions, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import {CustomerApplication} from '../customer-application';
import {SharedDataService} from '../shared/shared-data/shared-data.service';



@Component({
  selector: 'app-audit',
  templateUrl: './audit.component.html',
  styleUrls: ['./audit.component.scss']
})
export class AuditComponent implements OnInit {
  @BlockUI() blockUI: NgBlockUI;
  closeResult: string;
  oldValue: CustomerApplication;
  newValue: CustomerApplication;
  auditLogs: AuditLog[];
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  dateTime: any;
  date: string;
  time: string;

  constructor(private sharedDataService: SharedDataService, private modalService: NgbModal, private restAPIService: RestAPIService, private datePipe: DatePipe) {
  }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      paging: true,
      'pageLength': 5,
      'lengthMenu': [5, 10, 25, 50, 75, 100]
    };
    this.getAuditLogs();
  }

  public getAuditLogs(): void {
    this.blockUI.start('Loading. Please Wait.');
    this.restAPIService.getAuditLogs().
      then(auditLogs => {

        for (let i = 0; i < auditLogs.length; i++) {
          auditLogs[i].time = this.datePipe.transform(auditLogs[i].time, 'MM/dd/yyyy HH:mm:ss');
        }
        this.auditLogs = auditLogs; this.dtTrigger.next(); this.blockUI.stop();
      })
      .catch(error => {
        this.blockUI.stop();
        this.sharedDataService.showError(error.message);
      });
  }
  open(content, log: AuditLog) {
    this.oldValue = log.oldValue;
    this.newValue = log.newValue;

    this.dateTime = this.oldValue.createdTS.split(' ');
    this.date = this.dateTime[0];
    this.date = this.datePipe.transform(this.dateTime[0], 'MM/dd/yyyy');
    this.time = this.dateTime[1];
    const options: NgbModalOptions = {
      size: 'lg',
      backdrop: 'static',
      keyboard: false
    };
    this.modalService.open(content, options).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
}
